import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';
import topLayerImg from '../../assets/images/mainmenu_top_layer.gif';
import middleLayerImg from '../../assets/images/mainmenu_mid_layer.gif';
import sublinkImg from '../../assets/images/mainmenu_sublink.gif';

const SideBar = (props) => {

    const sideBarTopLayer = (firstElement, secondList, firstIndex) =>{
        const _key = firstIndex.toString();
        const firstElementTextNode = firstElement;

        //console.log("1st" + _key);
        return(
            <ListGroup className='topLayer'>
                <ListGroupItem tag="a" action key={_key} onClick={props.clickTopLayerInfo}
                className='topLayerContent' data-value={firstElement} style={{cursor:"pointer"}}>
                    <img alt="*" src={topLayerImg} />
                    {firstElementTextNode}
                </ListGroupItem>
                {secondList.map((middleLayerContent, secondIndex) =>{
                    return sideBarMiddleLayer(middleLayerContent, firstIndex, secondIndex);
                })}
            </ListGroup>            
        )
    }

    const sideBarMiddleLayer = (middleLayerContent, firstIndex, secondIndex) =>{
        const _key =firstIndex.toString() + secondIndex.toString();
        const secondElementTextNode = middleLayerContent.secondElement;

        //console.log("2nd" + _key);
        return(
        <ListGroup className='middleLayer'>
            <ListGroupItem tag="a" action key={_key} onClick={props.clickMiddleLayerInfo}
            className='middleLayerContent' data-value={middleLayerContent.secondElement} 
            style={{ paddingLeft: "38px", cursor:"pointer"}}>
                <img alt="*" src={middleLayerImg} />
                {secondElementTextNode}
            </ListGroupItem>
            {middleLayerContent.thirdList.map((bottomLayerContent, thirdIndex) =>{
                return sideBarBottomLayer(bottomLayerContent, firstIndex, secondIndex ,thirdIndex);
            })}
        </ListGroup>   
        )
    }

    const sideBarBottomLayer = (bottomLayerContent, firstIndex, secondIndex ,thirdIndex) =>{
        const _key =firstIndex.toString() + secondIndex.toString() + thirdIndex.toString();
        const thirdElementTextNode = bottomLayerContent.thirdElement

        //console.log("3rd" + _key);
        return(
            <ListGroup className='bottomLayer'>
                <ListGroupItem tag="a" action key={_key} onClick={props.clickBottomLayerInfo} 
                className='bottomLayerContent' data-value={bottomLayerContent.thirdElement}
                style={{ paddingLeft: "55px", cursor:"pointer"}}>
                    <img alt="->" src={sublinkImg} />
                    {thirdElementTextNode}
                </ListGroupItem>
            </ListGroup>   
        )
    }

    return(
        <>
            {sideBarTopLayer(props.firstElement, props.secondList, props.index)}
        </>
    )
}

export default SideBar;